import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 文件导入 ")
const _hoisted_2 = { class: "scroll-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "上传的Excel表符合以下规范:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "● 文件大小不超过10M，且单个sheet页数据量不超过1000行", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "● 仅支持(.xls和*.xlsx)文件", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "● 请确保您需要导入的sheet表头中不包含空的单元格，否则该sheet页数据系统将不做导入", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "● 批量导入的数据不支持以“内置变量”作为条件的过滤", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "● 导入文件不支持Excel公式计算，如SUM(A1:B3 A2:C2)等", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "● 导入文件会覆盖已有信息，如需更新，请先导出数据，在导出表格里进行修改后再上传", -1)

import { ref, onMounted, computed, onUnmounted } from "vue";
import SelectFile from "./select-file.vue";
import DataPreview from "./data-preview.vue";
import DataValid from "./data-valid.vue";
import FinishImport from "./finish-import.vue";
import NP from "number-precision";
import { debounce } from "lodash";
import { message } from "ant-design-vue";

import { defineComponent } from "vue";
import { FormMultipleImportService } from "./form-multiple-import.service";
const __default__ = defineComponent({
  isGlobal: true,
  name: "FormMultipleImport",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  excelDataApiUrl: {
    type: String,
    required: true,
  },
  // uploadApiFn: {
  //   type: Function,
  //   required: true,
  // },
  // backPage: {
  //   type: String,
  //   required: true,
  // },
  modelUrl: {
    type: String,
  },
  templateKey: {
    type: String,
  },
  columns: {
    type: Array,
    default: () => [],
  },
  keyFields: {
    type: Array,
    default: () => [],
  },
  checkType: {
    type: String,
  },
},
  emits: ["refresh", "loadData"],
  setup(__props, { emit }) {

const props = __props





const visible = ref(false);
const checkKey = ref<string>("");

const currentStep = ref(0);
const checkLoading = ref(true);
let timer;
const { run, data, loading } = FormMultipleImportService.useGetExcelData();
const { run: runCheck, data: checkData } = FormMultipleImportService.useGetCheckData();

const tableData = computed(() => {
  return {
    failList: data?.value?.failList?.slice(0, 100) || [],
    originalList:
      data?.value?.originalList?.slice(0, 100) || data?.value?.initialList?.slice(0, 100) || [],
    passList: data?.value?.passList?.slice(0, 100) || [],
  };
});

async function finishUpload(url) {
  if (url && run) {
    const res = await run(props.excelDataApiUrl, url);
    if (res?.respCode === "0000") {
      currentStep.value = 1;
      checkKey.value = res?.data?.key || "";
    }
  }
}

function setSteps(step: number) {
  currentStep.value = step;
  if (step === 2) {
    loadCheckData();
  }
  if (step === 3) {
    emit("loadData", checkData.value?.passList);
  }
}
const emitData=(data) => {
  // console.log("🚀 ~ file: index.vue:151 ~ emitData ~ data:", data)
  currentStep.value = 3;
  emit("loadData", data);
}

const loadCheckData = async () => {
  let count = 0;
  checkLoading.value = true;
  async function intervalFn() {
    const res = await runCheck(checkKey.value);
    count++;
    if (res?.respCode === "0000" && checkData.value?.status == 3) {
      clearInterval(timer);
      checkLoading.value = false;
    } else if (checkData.value?.status == 3) {
      clearInterval(timer);
      checkLoading.value = false;
      message.warn("数据校验超时，请重新上传文件");
      setSteps(1);
    }
    if (count > 30||!checkKey.value) {
      clearInterval(timer);
      checkLoading.value = false;
    }
  }
  const r = await runCheck(checkKey.value);
  if (r?.respCode === "0000" && checkData.value?.status == 3) {
    checkLoading.value = false;
  } else if (checkData.value?.status == 3) {
    clearInterval(timer);
    checkLoading.value = false;
    message.warn("数据校验超时，请重新上传文件");
    setSteps(1);
  } else if (checkData.value?.status == -1) {
    clearInterval(timer);
    checkLoading.value = false;
    message.warn("上传文件有错误，请检查后重新上传");
    setSteps(1);
  }else {
    timer = setInterval(intervalFn, 3000);
  }
};

const tableHeight = ref(200);
function calcTableHeight() {
  const doumentHeight = window.innerHeight > 1000 ? 1000 : window.innerHeight;

  const calcHeight = NP.minus(NP.times(doumentHeight, 0.8), 235);
  tableHeight.value = calcHeight > 200 ? calcHeight : 200;
}
onMounted(() => {
  calcTableHeight();
});

const deCalcTableHeight = debounce(calcTableHeight, 200);

window.addEventListener("resize", deCalcTableHeight);

function closeModal() {
  currentStep.value = 0;
  // emit("loadData",data.originalList);
  data && (data.value = undefined);
  checkLoading.value = true;
  checkKey.value = "";
  timer && clearInterval(timer);
}

onUnmounted(() => {
  window.removeEventListener("resize", deCalcTableHeight);
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true)),
      style: {"display":"inline-block"}
    }, [
      _renderSlot(_ctx.$slots, "importBtn", {}, () => [
        _createVNode(_component_a_button, { style: {"margin":"0 15px"} }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      class: "organization-import--modal",
      title: "导入数据",
      width: "65%",
      footer: false,
      "destroy-on-close": true,
      "after-close": closeModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_steps, { current: currentStep.value }, {
            default: _withCtx(() => [
              _createVNode(_component_a_step, { title: "选择EXCEL表" }),
              _createVNode(_component_a_step, { title: "数据预览" }),
              _createVNode(_component_a_step, { title: "导入校验" }),
              _createVNode(_component_a_step, { title: "导入数据" })
            ]),
            _: 1
          }, 8, ["current"]),
          (currentStep.value === 0)
            ? (_openBlock(), _createBlock(SelectFile, {
                key: 0,
                "loading-request": _unref(loading),
                "model-url": __props.modelUrl,
                templateKey: __props.templateKey,
                onFinishUpload: finishUpload
              }, {
                standard: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "limit", {}, () => [
                    _hoisted_3,
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7,
                    _hoisted_8,
                    _hoisted_9
                  ])
                ]),
                _: 3
              }, 8, ["loading-request", "model-url", "templateKey"]))
            : _createCommentVNode("", true),
          (currentStep.value === 1)
            ? (_openBlock(), _createBlock(DataPreview, {
                key: 1,
                data: _unref(tableData),
                columns: __props.columns,
                tableHeight: tableHeight.value,
                onSetSteps: setSteps
              }, null, 8, ["data", "columns", "tableHeight"]))
            : _createCommentVNode("", true),
          (currentStep.value === 2)
            ? (_openBlock(), _createBlock(DataValid, {
                key: 2,
                data: _unref(checkData),
                columns: __props.columns,
                checkLoading: checkLoading.value,
                tableHeight: tableHeight.value,
                onSetSteps: setSteps,
                onEmitData: emitData,
                keyFields: __props.keyFields,
                originalList: _unref(tableData).originalList,
                checkKey: checkKey.value,
                checkType: __props.checkType
              }, null, 8, ["data", "columns", "checkLoading", "tableHeight", "keyFields", "originalList", "checkKey", "checkType"]))
            : _createCommentVNode("", true),
          (currentStep.value === 3)
            ? (_openBlock(), _createBlock(FinishImport, {
                key: 3,
                onHandleClose: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 3
    }, 8, ["visible"])
  ], 64))
}
}

})